export const journalGetters = {};
